import React from "react";
import cx from "classnames";
import snarkdown from "snarkdown";
//

export default function Alert({
  text,
  children,
  className,
  info,
  warning,
  success,
  error
}) {
  className = cx(className, "alert", {
    "alert--info": info,
    "alert--warning": warning,
    "alert--success": success,
    "alert--danger": error
  });

  if (text) {
    children = text
      .split("|")
      .map((text, idx) => (
        <p key={idx} dangerouslySetInnerHTML={{ __html: snarkdown(text) }} />
      ));
  }

  return <div className={className}>{children}</div>;
}
